import InternalAPI from "../../../../../app/axios.js"
import "../types"

/** @borrows InternalAPI */
export default class CorporatePodcastListRepository extends InternalAPI {
    constructor() {
        super();
        /** @type {string} */
        this.endpoint = "/v2/corporate_podcast/admin"
    }

    /**
     *
     * @param queries
     * @return {Promise<{data, err: null}|{data: *[], err: string}|{data: null, err: *}>}
     */
    async getAll(queries) {
        try {
            const res = await this.$axios.get(this.endpoint + "/data?" + queries)
            if (res.status === 200) {
                return {data: res.data.data.data, err: null}
            }
            return {data: [], err: "something went wrong"}
        } catch (err) {
            return {data: null, err: this.setErrorMessage(err.response)}
        }
    }
}
